import * as React from 'react';
const h = React.createElement;

export interface SpaceProps {
  direction?: 'horizontal' | 'vertical';
  size?: 'small' | 'middle' | 'large' | number;
  wrap?: boolean;
  style?: React.CSSProperties;
  className?: string;
  children?: React.ReactNode;
}

const Space: React.FC<SpaceProps> = function Space(props) {
  const {
    direction = 'horizontal',
    size = 'small',
    wrap = false,
    style,
    className = '',
    children,
  } = props;
  const sizeMap: Record<'small' | 'middle' | 'large', number> = {
    small: 8,
    middle: 16,
    large: 24,
  };
  const gap = typeof size === 'number' ? size : (sizeMap[size] ?? 8);
  const isHorizontal = direction === 'horizontal';

  return h(
    'div',
    {
      className: `flex ${isHorizontal ? 'flex-row' : 'flex-col'} ${wrap ? 'flex-wrap' : ''} ${className}`,
      style: { gap, ...(style || {}) },
    },
    children,
  );
};

export { Space };
